<template>
    <span
        class="mr-2 inline-block border px-2 py-0.5 text-xs font-bold uppercase"
    >
        <span class="text-black">
            <slot />
        </span>
    </span>
</template>